import { render, staticRenderFns } from "./LoginMenuButtonNew.vue?vue&type=template&id=4067498b&scoped=true"
import script from "./LoginMenuButtonNew.vue?vue&type=script&setup=true&lang=ts"
export * from "./LoginMenuButtonNew.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./LoginMenuButtonNew.vue?vue&type=style&index=0&id=4067498b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4067498b",
  null
  
)

export default component.exports